import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        // Core layout styles
        "flex h-9 w-full rounded-md border border-dark-grey px-3 py-1 text-base shadow-sm transition-colors",

        // Default state
        "border border-dark-grey bg-transparent placeholder:text-field-grey",

        // Focus state: white background + red ring
        "focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-imperial-red focus-visible:bg-swan",

        // ✅ Filled state (NOT just focus): white background if the user has typed something
        // This uses CSS :placeholder-shown logic — only works if a placeholder is present
        "[&:not(:placeholder-shown)]:bg-swan", // long-term scalable & no JS needed

        // ✅ Focus state override: remove default border, show imperial red ring and white background
        "focus-visible:border-transparent focus-visible:ring-1 focus-visible:ring-imperial-red focus-visible:bg-swan",

        // Disabled state
        "disabled:cursor-not-allowed disabled:opacity-50",

        // Responsive text sizing
        "md:text-sm",

        // Allow custom class overrides
        className
      )}
      // ✅ Required for the :placeholder-shown trick to work — must contain some placeholder (can be just a space)
      placeholder=" "
      // Standard setup
      ref={ref}
      {...props}
    />
  );
})
Input.displayName = "Input"

export { Input }